<template>
  <Card
    style="background-color: white"
    :title="orderData.groupTitle"
    :desc="orderData.examTitle"
    :thumb="orderData.groupImg"
  >
    <template #price>
      <span style="color: #b5b5b5"
        >课群ID: {{ orderData.groupId }}<br />考试ID:
        {{ orderData.examId }}</span
      >
    </template>
  </Card>
</template>
<script setup>
import { Card } from "vant";
import { useOrder } from "@/composables/useOrder";
const { orderData } = useOrder();
</script>
